<template>
    <div class="role_warp">
      <!-- 头部工具栏 -->
      <div class="role_heard_tool">
        <el-button
          type="success"
          size="mini"
          
          @click="getList"
          >刷新</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px"
          @click="select()"
          >筛选</el-button
        >
      </div>
      <div class="head_search">
        <div class="item_warp">
          <label style="margin: 0 10px;">用户</label>
          <el-input
            v-model="uid"
            placeholder="请输入用户"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
        <label style="margin: 0 10px">是否已提现</label>
        <el-select
          v-model="isWith"
          style="width: 100px"
          placeholder="请选择"
          clearable
        >
          <el-option label="不限" value=""></el-option>
          <el-option label="已提现" value="true"></el-option>
          <el-option label="未提现" value="false"></el-option>
        </el-select>
      </div>
      
      </div>
      <!-- 表单 -->
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="calc(100vh - 240px )"
        style="width: 921px"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="memberUid" label="用户" width="100" />
        <el-table-column prop="myAmount" label="已获得奖励金额" width="150">
          <template #header>
          <div class="flex">
            <div class="gbRed">
              <div>已获得奖励金额</div>
            </div>
            <img
              @click="selectOrder('已获得奖励金额', 'asc')"
              v-if="myAmount == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt="" 
            />
            <img
              @click="selectOrder('已获得奖励金额', '')"
              v-if="myAmount == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('已获得奖励金额', 'desc')"
              v-if="myAmount == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
        <el-table-column prop="inviteCount" label="已邀请好友数" width="150">
          <template #header>
          <div class="flex">
            <div class="gbRed">
              <div>已邀请好友数</div>
            </div>
            <img
              @click="selectOrder('已邀请好友数', 'asc')"
              v-if="inviteCount == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('已邀请好友数', '')"
              v-if="inviteCount == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('已邀请好友数', 'desc')"
              v-if="inviteCount == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="questionCount" label="下级统计" width="120">
          <template slot-scope="scope">
          <div style="text-align: start;">
            <div>总注册 {{ scope.row.childrenCount }}</div>
            <div>非同IP {{ scope.row.childrenIpCount }}</div>
            <div>今日注册 {{ scope.row.todayChildrenCount }}</div>
            <div>今日非同IP {{ scope.row.todayChildrenIpCount }}</div>
          </div>
        </template>
        </el-table-column>
        <el-table-column prop="questionCount" label="答题剩余次数" width="120" />
        <el-table-column prop="drawCount" label="抽奖剩余次数" width="120" />
        <el-table-column prop="isWith" label="是否已提现" width="110">
        <template slot-scope="scope">
          <div v-if="scope.row.isWith" style="color:#06CC00">是</div>
          <div v-if="!scope.row.isWith" style="color:red">否</div>
        </template>
      </el-table-column>
        <el-table-column prop="lastUploadDate" label="提现时间" width="170">
            <template slot-scope="scoped">
                <div  v-if="scoped.row.withDate">
                {{ happenTimeFun(scoped.row.withDate) }}
             </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="getList"
      />
    </div>
  </template>
  
  <script>
  import Pagination from "@/components/Pagination"; // 引入分页器
  import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
  import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
  
  import validEmail from "@/utils/validate"; // 引入邮箱验证方法
  import md5 from "js-md5"; // 引入Md5加密
  
  export default {
    name: "Management",
    components: { Pagination,VueUeditorWrap,UploadImage },
    data() {
      return {
        option: "", // 初始选项
        options: [], // 选择角色
        name: "", // 搜索的管理员名称
        tableData: [], // 展示的表单信息
        // 添加表单
        active: {},
        // 修改表单
        editForm: { },
        total: 0, // 总数
        pageNum: 1, // 页码值
        pageSize: 20, // 页大小
        multipleSelection: [], // 选中项s
        yiFangDetailList: [], // 
        dialogVisible: false, // 添加弹窗
        dialog: false, // 添加弹窗
        edit_dialogVisible: false, // 编辑弹窗
        Isedit: false, // 是否是编辑弹窗
        loading: false, // 表格加
        buttongLoding: false, // 按钮加载
        sn:'',
        lang:'en',
        isEnabled:false,
        isChat:false,
        isTelegram:false,
        isWhatsApp:false,
        isMessenger:false,
        isLinkUrl:false,
        isTelegramGroup:false,
        dialogVisibleUpdate:false,
        dataTime:['',''],
        yifangId:'',
        status:'',
        uid:'',
        isWith:'',
        myAmount:'',
        inviteCount:'',
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      handleClickItem() {
        this.$nextTick(() => {
          // 获取遮罩层dom
          const domImageMask = document.querySelector('.el-image-viewer__mask')
          if (!domImageMask) {
            return
          }
          domImageMask.addEventListener('click', () => {
            // 点击遮罩层时调用关闭按钮的 click 事件
            document.querySelector('.el-image-viewer__close').click()
          })
        })
      },
      // 筛选
      select() {
        this.pageNum = 1;
        this.getList();
      },
      // 批量审核通过
    checkSuccessList(type,row){
        if(type == 1){
            var ids = [row.id];
            var params = {
               ids: ids.toString(),
            };
      this.$api.operate
        .approveList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });

        }
        if(type == 2){
            if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否批量审核通过?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .approveList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      })

        }
    },
    checkRejectList(type,row){
        if(type == 1){
            var ids = [row.id];
            var params = {
               ids: ids.toString(),
            };
      this.$api.operate
        .rejectList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });

        }
      if(type == 2){
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否批量审核拒绝?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .rejectList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      }).catch(() => {
        
        });
      }
    },
    selectOrder(name, type) {
      this.myAmount = "";
      this.inviteCount = "";
      if (name == "已获得奖励金额") {
        this.myAmount = type;
      }
      if (name == "已邀请好友数") {
        this.inviteCount = type;
      }
    
     
      this.pageNum = 1;
      this.getList();
    },
      // 获取表单信息
      getList() {
        var params = {
          pageNumber: this.pageNum,
          pageSize: this.pageSize,
          uid:this.uid,
          isWith:this.isWith,
          myAmount:this.myAmount,
          inviteCount:this.inviteCount
        };
        this.loading = true;
        this.$refs.gridTable.bodyWrapper.scrollTop = 0;
          this.$api.operate
          .memberPaa(params)
          .then((res) => {
            this.tableData = res.records;
            this.total = res.total;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 选择或者取消行，支持全选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 关闭添加弹窗
      handleClose() {
        this.$refs.active.resetFields();
      },
      // 关闭修改弹窗
      editClose(done) {
        this.editInfo = {};
        done();
      },
      // 删除选中项
      handleDel() {
        var ids = [];
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
        var params = {
          ids: ids.toString(),
        };
        this.$api.operate
          .bannerDelete(params)
          .then((res) => {
            this.$message.success(res);
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.getList();
          });
      },
      happenTimeFun(num){
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d; //天补0
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s; //秒补0
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
  },
      // 添加用户
      bannerSave() {
            this.$api.operate
              .bannerSave(this.active)
              .then((res) => {
                this.$message.success(res);
                this.dialogVisible = false;
                this.getList();
              })
              .catch((err) => {
                this.$message.error(err || "服务器错误，请稍后重试");
              })
              .finally(() => {
                this.buttongLoding = false;
              });
      },
      // 打开删除弹窗
      openDelete() {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        this.$confirm("是否删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.handleDel();
          })
          .catch(() => {
            
          });
      },
     
    },
  };
  </script>
  <style lang="scss" scoped>
  .role_warp {
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    .role_heard_tool {
      margin-bottom: 10px;
    }
    .edit_titile {
      .dialog_input {
        // width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        span {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
        }
        .el-input {
          flex: 3;
        }
      }
    }
    .tree {
      margin-top: 25px;
      display: flex;
      justify-content: space-around;
    }
    .authority_info {
      margin-top: 25px;
    }
  }
  .el-input {
    width: 70%;
  }
  </style>
  